package com.dotdrives.web.pages.drives

import com.dotdrives.controller.DriveDetailController
import com.dotdrives.controller.DriveDetailUiState
import com.dotdrives.web.ui.DotButton
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.textarea
import web.cssom.ClassName
import web.dom.ElementId
import web.html.InputType
import web.html.text

external interface DriveNoteComposerProps : Props {
    var state: DriveDetailUiState
    var controller: DriveDetailController
}

val DriveNoteComposer = FC<DriveNoteComposerProps> { props ->
    div {
        className = ClassName("drives-composer")
        input {
            id = ElementId("drive-note-title")
            type = InputType.text
            value = props.state.noteDraftTitle
            placeholder = "Note title (optional)"
            ariaLabel = "Note title"
            onChange = {
                props.controller.updateNoteDraft(it.currentTarget.value, props.state.noteDraftBody)
            }
        }
        textarea {
            id = ElementId("drive-note-body")
            value = props.state.noteDraftBody
            placeholder = "What happened?"
            ariaLabel = "Note body"
            onChange = {
                props.controller.updateNoteDraft(props.state.noteDraftTitle, it.currentTarget.value)
            }
        }
        div {
            className = ClassName("drives-composer-actions")
            DotButton {
                text = "Save note"
                onClick = props.controller::saveNote
                loading = props.state.savingNote
                enabled = props.state.noteDraftBody.isNotBlank()
                className = "drives-topbar-button"
            }
        }
    }
}
